<template>
    <div class="step-five-content-container">
        <div class="options-container step-five-container">
            <span class="container-title">
                {{ $t('intervention.stepfive.option.title') }}
            </span>
            <div class="option-container">
                <Switch @toggle="toggleRecurrente" :active="recurrente" :aria-label="$t('intervention.stepfive.option.recurrent')" />
                <span class="title" aria-hidden="true">
                    {{ $t('intervention.stepfive.option.recurrent') }}
                </span>
                <ReglePastille cle="demandeIntervention.interventionRecurrente" />
            </div>
            <div class="option-container">
                <Switch @toggle="toggleSuivi" :active="suivi" :aria-label="$t('intervention.stepfive.option.suivi')" />
                <span class="title" aria-hidden="true">
                    {{ $t('intervention.stepfive.option.suivi') }}
                </span>
                <ReglePastille cle="demandeIntervention.suiviDemande" />
            </div>

            <ContactList v-if="suivi"/>
        </div>
        <div class="contacts-container step-five-container">
            <span class="container-title">
                {{ $t('intervention.stepfive.contacts.title') }}
            </span>
            <ContactSurSiteList />
        </div>
    </div>
</template>

<script lang="ts">
import ContactList from './ContactList.vue';
import Switch from '@/components/ui-components/Switch.vue';
import { defineComponent } from 'vue';
import { INTERVENTION } from '../store/mutation-types';
import ContactSurSiteList from './ContactSurSiteList.vue';
import { InterventionModuleAction } from '@/modules/Intervention/store/actions-types';
import ReglePastille from '@/components/regles/ReglePastille.vue';

export default defineComponent({
    components: { Switch, ContactList, ContactSurSiteList, ReglePastille },
    async beforeMount() {
        await this.$store.dispatch(InterventionModuleAction.PREFILL_CONTACTS_SUIVI);
    },
    computed: {
        suivi() {
            return this.$store.getters.getInterventionSuiviValue;
        },
        recurrente() {
            return this.$store.getters.getInterventionRecurrenteValue;
        },
    },
    methods: {
        toggleSuivi() {
            this.$store.commit(INTERVENTION.SET_SUIVI, !this.suivi);
        },
        toggleRecurrente() {
            this.$store.commit(INTERVENTION.SET_RECURRENTE, !this.recurrente);
        },
    },
});
</script>

<style scoped>
.option-container {
    margin: 8px 0;
    display: flex;
    align-items: center;
}
.container-title {
    display: flex;
    color: var(--color-principal);
    font-family: 'Raleway Semi Bold', sans-serif;
    font-variant-numeric: lining-nums;
    font-size: 18px;
    margin-bottom: 16px;
}
.title {
    margin-left: 8px;
}
.step-five-content-container {
    display: flex;
    flex-direction: column;
    gap: 8px;
    height: calc(100vh - 250px);
    overflow-y: auto;
}
.step-five-container {
    border-radius: 4px;
    padding: 16px 24px;
    background-color: var(--white);
    box-shadow: 0 3px 1px -2px rgba(0, 0, 0, 0.2), 0 2px 2px rgba(0, 0, 0, 0.14), 0 1px 5px rgba(0, 0, 0, 0.12);
}


</style>
